import { productNames } from './config';
import memoizee from 'memoizee';
import { retrieveUserAccess, UserModulesData } from './utils';

export const memoizedUserAccessCall = memoizee<() => Promise<UserModulesData>>(retrieveUserAccess, {
  promise: true,
  maxAge: 60000,
});

const getAuthorisedProductNames = async (): Promise<string[]> => {
  const memoizedResponse = await memoizedUserAccessCall();

  const products = memoizedResponse?.products || [];
  const productsDisplayNames = products.map((value: string) => productNames[value] || value);
  return productsDisplayNames;
};

const getAuthorisedProductValues = async (): Promise<string[]> => {
  const memoizedResponse = await memoizedUserAccessCall();
  const products = memoizedResponse?.products || [];

  return products;
};

const getAuthorisedProductNameFromValue = (accessValue: string) => {
  return productNames[accessValue] || accessValue;
};

const getAuthorisedModuleValues = async (): Promise<string[]> => {
  const memoizedResponse = await memoizedUserAccessCall();
  const modules = memoizedResponse?.modules || [];

  return modules;
};

// don't expose it in the public API, so keep it out of the authorisation object
export const resetAuthorisationCache = () => memoizedUserAccessCall.clear();

export const authorisation = {
  getAuthorisedProductNames,
  getAuthorisedProductValues,
  getAuthorisedProductNameFromValue,
  getAuthorisedModuleValues,
};
